// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310604/js/" + chunkId + "." + {"44":"02595a57","225":"ccb81c43","481":"3cfd5f83","486":"469a01a1","770":"f6df5735"}[chunkId] + ".0.06888448357696575.chunk.js";
};